import { Shell, StepFooter } from "@/components/Shell";
import { OptionList } from "@/components/OptionList";
import { LIFESTYLE_QUESTIONS } from "@/lib/questions";

export function LifestyleStep({ answers, setAnswer, onBack, onNext, progress }) {
  const questions = Object.values(LIFESTYLE_QUESTIONS);

  return (
    <Shell progress={progress}>
      <span className="cc-eyebrow">Estilo de vida</span>
      <h1 className="font-serif text-3xl sm:text-4xl mt-3">
        Tus hábitos y entorno
      </h1>
      <p className="mt-3 text-[hsl(var(--muted-foreground))]">
        Información breve sobre sueño, actividad, alimentación y apoyo emocional.
      </p>

      <div className="mt-6 space-y-4">
        {questions.map((q) => (
          <div key={q.id} className="cc-card p-5">
            <p className="font-medium mb-3">{q.text}</p>
            <OptionList
              name={q.text}
              options={q.options}
              value={answers[q.id]}
              onChange={(v) => setAnswer(q.id, v)}
              testIdPrefix={q.id}
            />
          </div>
        ))}

        <div className="cc-card p-5">
          <p className="font-medium mb-3">
            Nivel de estrés en las últimas 2 semanas (0 = ninguno, 10 = extremo)
          </p>
          <div className="flex items-center gap-4">
            <input
              type="range"
              min={0}
              max={10}
              step={1}
              value={typeof answers.stress === "number" ? answers.stress : 5}
              onChange={(e) => setAnswer("stress", Number(e.target.value))}
              className="flex-1 accent-[hsl(var(--olivo))]"
              data-testid="stress-slider"
              aria-label="Nivel de estrés"
            />
            <span
              className="cc-chip min-w-[3rem] justify-center text-base font-serif"
              data-testid="stress-value"
            >
              {typeof answers.stress === "number" ? answers.stress : 5}
            </span>
          </div>
        </div>
      </div>

      <StepFooter>
        <button onClick={onBack} className="cc-btn-outline" data-testid="lifestyle-back-btn">
          Atrás
        </button>
        <button onClick={onNext} className="cc-btn-primary" data-testid="lifestyle-next-btn">
          Ver resultado
        </button>
      </StepFooter>
    </Shell>
  );
}
